var _path;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgZdh(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1742528210475,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 2612,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M914 86.9H641c-28.5 0-42.8 34.4-22.7 54.6l110.3 110.6-138.4 138c-14.3 14.2-14.3 37.3-0.1 51.6 14.2 14.3 37.3 14.3 51.6 0.1l138.4-138 110.3 110.6c20.1 20.2 54.6 6 54.7-22.5l0.8-273c0.2-17.6-14.2-32-31.9-32zM450.2 531.9l-138.4 138-110.3-110.6c-20.1-20.2-54.6-6-54.7 22.5l-0.8 273c-0.1 17.7 14.3 32.1 32 32.1h273c28.5 0 42.8-34.4 22.7-54.6L363.3 721.6l138.4-138c14.3-14.2 14.3-37.3 0.1-51.6s-37.3-14.3-51.6-0.1z",
    fill: "#1296db",
    "p-id": 2613
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZdh);
export default __webpack_public_path__ + "static/media/zdh.75f3dc4f.svg";
export { ForwardRef as ReactComponent };